
import { useEffect, useState } from "react";
import { removePaymentLink, useCheckInCosts, useCurrentEvent } from "../firebase/firebase";
import styles from "./guest-check-in.module.css"
import { ReactComponent as AddSVG } from './add-button.svg';
import { ReactComponent as MinusSVG } from './minus-button.svg';
import { requestPaymentLink } from "../firebase/firebase";
import { useSearchParams } from "react-router-dom";

export default function GuestCheckIn({setShowNavBar}) {
    const [persons, setPersons] = useState([{id: Math.random()}]);
    const [billData, setBillData] = useState([]);
    const costs = useCheckInCosts();

    useEffect(() => setShowNavBar(false), []);
    const currentEvent = useCurrentEvent();

    const availableActivities = [];

    const removePerson = (id) => {
        const index = persons.findIndex((person) => person.id === id);

        if(index !== -1) {
            persons.splice(index, 1);
            setPersons([...persons]);
        }

        onUpdate();
    }    
    const addPerson = () => {
        setPersons([...persons, {id: Math.random()}]);
        onUpdate();
    }

    if(currentEvent?.locations?.includes("Giant Swing"))
        availableActivities.push("Giant Swing");
    if(currentEvent?.locations?.includes("Zipline"))
        availableActivities.push("Zipline");
    if(currentEvent?.locations?.includes("Swimming Pool"))
        availableActivities.push("Swimming Pool");
    if(currentEvent?.locations?.includes("Leap of Faith"))
        availableActivities.push("Leap of Faith");

    const onUpdate = () => {

        const newBillData = [];

        for(let i = 0; i < persons.length; i++) {
            const name = document.getElementById(`name-${i}`).value;
            const age = document.getElementById(`age-${i}`).value || 10;
            const arrival = document.getElementById(`arrival-${i}`).value;
            const departure = document.getElementById(`departure-${i}`).value;
            const meals = document.getElementById(`meals-${i}`).value;

            const giant_swing = document.getElementById(`check-g-${i}`)?.checked;
            const swimming_pool = document.getElementById(`check-s-${i}`)?.checked;
            const zip_line = document.getElementById(`check-z-${i}`)?.checked;
            const leap_of_faith = document.getElementById(`check-l-${i}`)?.checked;

            newBillData.push({name, age, arrival, departure, meals, giant_swing, swimming_pool, zip_line, leap_of_faith});
        }

        setBillData(newBillData);
    }

    const getLink = (e) => {
        e.preventDefault();
        const formData = { church: e.target[0].value, persons: [], status: 'awaiting link' }

        for(let i = 0; i < e.target.length - 2; i += 5 + availableActivities.length) {
            var person = {
                name: e.target[1 + i + 0].value,
                age: Number(e.target[1 + i + 1].value),
                arrival: e.target[1 + i + 2].value,
                departure: e.target[1 + i + 3].value,
                meals: Number(e.target[1 + i + 4].value),

                giant_swing: false,
                swimming_pool: false,
                zip_line: false,
                leap_of_faith: false
            }

            for(let j = 0; j < availableActivities.length; j++) {
                if(e.target[1 + i + j + 5].id.includes("check-g"))
                    person.giant_swing = e.target[1 + i + j + 5].checked;
                else if(e.target[1 + i + j + 5].id.includes("check-s"))
                    person.swimming_pool = e.target[1 + i + j + 5].checked;
                else if(e.target[1 + i + j + 5].id.includes("check-z"))
                    person.zip_line = e.target[1 + i + j + 5].checked;
                else if(e.target[1 + i + j + 5].id.includes("check-l"))
                    person.leap_of_faith = e.target[1 + i + j + 5].checked;
            }
            formData.persons.push(person);
        }

        requestPaymentLink(formData, (link) => {
            var win = window.open(link, '_self');
            win.focus();            
        });

        document.getElementsByClassName(styles.loader_pizza)[0].classList.add(styles.show);
    }

    return (
        <div style={{padding: '1rem'}}>
            <h1>Guest Check-In Form</h1>
            <table>
                <tr>
                    <td>
                        <div className={styles.interconnect_tile_full} style={{marginBottom: '2rem'}}>
                            <p> Welcome to Camp Chautauqua! Please fill out the below form to check-in.<br/>
                                Please add all family members who will be visiting with you.<br/>
                                <span style={{fontStyle: 'italic'}}>(Children 5 years and younger are free)</span></p>
                            <p style={{fontStyle: 'italic'}}>Current Event: {currentEvent?.name}</p>
                        </div>  
                    </td>
                </tr>
                <tr>
                    <td>
                        <form onSubmit={(e) => getLink(e)} id={styles.check_in_form} className={styles.interconnect_tile_full}>
                            <div style={{marginBottom: '1rem'}}>
                                <label htmlFor="church" style={{marginRight: '8px'}}>Church:</label>
                                <input id="church" required/>
                            </div>                
                            <div className="h-scroll">
                                <table>
                                    <thead>
                                        <tr>
                                            <th className={styles.no_border}/>
                                            <th>Name</th>
                                            <th>Age</th>
                                            <th>Arrival</th>
                                            <th>Expected Departure</th>
                                            <th>Meals</th>
                                            <th>Premier Activities</th>
                                        </tr>
                                    </thead>
                                    <tbody id='person-table'>
                                        {
                                            persons.map((person, i) => <GuestInfoLine key={`gil-${person.id}`} index={i} activities={availableActivities} person={person} remove={removePerson} onUpdate={onUpdate}/>)
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div id={styles.bottom_panel}>
                                <div id={styles.add} onClick={() => addPerson()}>
                                    <AddSVG id='add-person' className={styles.circle_button}/>
                                    <p>Add Person</p>
                                </div>                    
                                <input type="submit" id="submit-form" style={{display: 'none'}}/>
                            </div>               
                        </form>
                    </td>
                </tr>
                <tr>
                    <td>
                        <BillPreview data={billData} costs={costs}/>
                    </td>
                </tr>
            </table>
        </div>
    )
}

function GuestInfoLine({index, activities, person, remove, onUpdate}) {
    return (
        <tr>
            <td className={styles.no_border}>{index == 0 ? <div/> : <MinusSVG className={styles.circle_button} onClick={() => remove(person.id)}/>}</td>
            <td><input id={`name-${index}`} name="name" type="text" autoComplete="name" required onChange={() => onUpdate()}/></td>
            <td><input id={`age-${index}`} name="age" type="number" required min='0' step='1' onChange={() => onUpdate()}/></td>
            <td><input id={`arrival-${index}`} name="arrival" type="datetime-local" required onChange={() => onUpdate()}/></td>
            <td><input id={`departure-${index}`} name="departure" type="datetime-local" required onChange={() => onUpdate()}/></td>
            <td>
                <input id={`meals-${index}`} name="meals" type="number" required min='0' step='1' onChange={() => onUpdate()}/>
            </td>
            <td>
                <div className={styles.activities}>
                    {
                        activities.map((act) => (
                            <div key={`C-${act[0]}-${person.id}`}>
                                <input id={`check-${act[0].toLocaleLowerCase()}-${index}`} name={"check-"+act} type="checkbox" onChange={() => onUpdate()}/>
                                <label htmlFor={`check-${act[0].toLocaleLowerCase()}-${index}`}>{act}</label>                            
                            </div>
                        ))
                    }
                </div>
            </td>
        </tr>
    )
}

function BillPreview({data, costs}) {    
    var totalCost = (costs?.daily_fee?.base_cost ?? 0) / 100;

    for(const person of data)
        totalCost += getCostPerPerson(person, costs);    

    return (
        <div className={styles.interconnect_tile_full} style={{marginTop: '2rem'}}>
            <h1 style={{fontSize: '1.5rem'}}>Price Overview</h1>
            <div className="h-scroll">
                <table id={styles.bill}>
                    <tbody>
                        {
                            data?.map((personData) => <BillPersonLine key={Math.random()} person={personData} costs={costs}/>)
                        }
                        <tr id={styles.fee_row}>
                            <td style={{position: 'relative'}}>
                                <h3 className={styles.person_name}>Family Day Fee</h3>
                            </td>
                            <td/>
                            <td/>
                            <td>
                                <h3>${((costs?.daily_fee?.base_cost ?? 0) / 100).toFixed(2)}</h3>
                            </td>                
                        </tr>
                        <tr id={styles.total_row}>
                            <td style={{position: 'relative'}}>
                                <h3 className={styles.person_name}>Total</h3>
                            </td>
                            <td/>
                            <td/>
                            <td>
                                <h3>${totalCost.toFixed(2)}</h3>
                            </td>                
                        </tr>
                    </tbody>
                </table>
            </div>

            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'end'}}>
                <button style={{marginRight: '1rem'}} onClick={() => {document.getElementById('submit-form').click()}}>Pay through Square</button>
                <div className={styles.loader_pizza}/>
            </div>
            
           
        </div>
    )
}
function BillPersonLine({person, costs}) {
    return (
        <>
            <tr>
                <td style={{position: 'relative'}}>
                    <h3 className={styles.person_name}>{person?.name}</h3>
                </td>
                <td/>
                <td/>
                <td>
                    <h3>${getCostPerPerson(person, costs).toFixed(2)}</h3>
                </td>                
            </tr>
            {
                (person?.meals > 0) ? 
                    <BillLineItem quantity={person?.meals} name={"Camp Meal"} costs={costs} person={person} item='meals'/>
                : null
            }
            {
                (person?.giant_swing) ? 
                    <BillLineItem quantity={1} name={"Premier Activity: Giant Swing"} costs={costs} person={person} item='giant_swing'/>
                : null
            }
            {
                (person?.zip_line) ? 
                    <BillLineItem quantity={1} name={"Premier Activity: Zip Line"} costs={costs} person={person} item='zip_line'/>
                : null
            }
            {
                (person?.swimming_pool) ? 
                    <BillLineItem quantity={1} name={"Premier Activity: Swimming Pool"} costs={costs} person={person} item='swimming_pool'/>
                : null
            }
            {
                (person?.leap_of_faith) ? 
                    <BillLineItem quantity={1} name={"Premier Activity: Leap of Faith"} costs={costs} person={person} item='leap_of_faith'/>
                : null
            }
        </>
    )
}
function BillLineItem({quantity, name, costs, item, person}) {
    
    const cost = ((person?.age <= 5 && costs?.[item]?.free_5_under) ? 0 : (costs?.[item]?.base_cost ?? 0)) / 100;

    return (
        <tr>
            <td>{quantity}x</td>
            <td>{name}{(person?.age <= 5 && costs?.[item]?.free_5_under) ? ' (5 and under)' : ''}</td>  
            <td>(${cost.toFixed(2)})</td>
            <td>${(cost * quantity).toFixed(2)}</td>
        </tr>
    )
}
function getCostPerPerson(person, costs) {
    var cost = 0;

    if(person?.meals > 0            && (person?.age > 5 || !(costs?.meals?.free_5_under)))          cost += person?.meals * (costs?.meals?.base_cost ?? 0) / 100;
    if(person?.giant_swing > 0      && (person?.age > 5 || !(costs?.giant_swing?.free_5_under)))    cost += (costs?.giant_swing?.base_cost ?? 0) / 100;
    if(person?.swimming_pool > 0    && (person?.age > 5 || !(costs?.swimming_pool?.free_5_under)))  cost += (costs?.swimming_pool?.base_cost ?? 0) / 100;
    if(person?.zip_line > 0         && (person?.age > 5 || !(costs?.zip_line?.free_5_under)))       cost += (costs?.zip_line?.base_cost ?? 0) / 100;
    if(person?.leap_of_faith > 0    && (person?.age > 5 || !(costs?.leap_of_faith?.free_5_under)))  cost += (costs?.leap_of_faith?.base_cost ?? 0) / 100;
    
    return cost;
}


export function GuestPaid({setShowNavBar}) {
    useEffect(() => setShowNavBar(false));

    const [searchParams, ] = useSearchParams();
    const id = searchParams.get('id');

    useEffect(() => {
        if(id !== undefined)
            removePaymentLink(id);
    }, []);

    return (
        <div id={styles.submitted_background}>
            <div id={styles.submitted_foreground}>
                <h1>Check In Process Complete</h1>
                <h2>Thank you!</h2>
                {/* <h3>Please go to this events check-in location to complete the check-in process</h3>
                <button className="interconnect-button" onClick={() => formToPDF(form)}
                    style={{color: 'black', padding: '8px 16px', fontSize: '1.25rem'}}>Print Form (PDF)</button>   */}
            </div>
        </div>
    );
}